export function COU_regOne(t, re) {
  if (!t) return false
  var arr = re.exec(t)
  if (arr && arr.length > 1) {
    return arr[1]
  }
  return false
}

export function COU_regOneStr(t, re) {
  var a = COU_regOne(t,re)
  if(!a)a = ""
  return a
}

export function COU_Trim2(content) {
  if (!content) content = ''
  content = content.replace(/ /g,'')
  content = content.replace(/\n+/g, "\n")
  return content
}

export function COU_formatDateToStr2(d, format) {
  var date = {
    'M+': d.getMonth() + 1,
    'd+': d.getDate(),
    'h+': d.getHours(),
    'm+': d.getMinutes(),
    's+': d.getSeconds(),
    'q+': Math.floor((d.getMonth() + 3) / 3),
    'S+': d.getMilliseconds(),
  }
  if (/(y+)/i.test(format)) {
    format = format.replace(
      RegExp.$1,
      (d.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  for (var k in date) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1
          ? date[k]
          : ('00' + date[k]).substr(('' + date[k]).length)
      )
    }
  }
  return format
}

export function COU_formatDateToStr(t) {
  var myDate = new Date()
  if(t)myDate = new Date(t)
  var da = COU_formatDateToStr2(myDate, 'yyyy-MM-dd hh:mm:ss')
  return da
}

export function COU_Sleep (time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

// 将字符串复制到剪切板
export const CopyToClipboard = str => {
  const el = document.createElement('textarea')
  el.value = str
  el.style.position = 'absolute'
  el.style.left = '-9999px'
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}

export const DownloadIamge = (url, name) => {
  const image = new Image()
  image.src = url
  image.setAttribute('crossOrigin', 'anonymous')
  image.onload = function () {
    const canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    const context = canvas.getContext('2d')
    context.drawImage(image, 0, 0, image.width, image.height)
    const url = canvas.toDataURL('image/jpg')
    // 生成一个a元素
    const a = document.createElement('a')
    // 创建一个单击事件
    const event = new MouseEvent('click')
    // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
    a.download = name || '图片'
    // 将生成的URL设置为a.href属性
    a.href = url
    // 触发a的单击事件
    a.dispatchEvent(event)
  }
}

// 数组对象根据指定key去掉重复的数据
export const COU_getRemoveRepeatData = (list, key) => {
	const obj = {}, arr = []
	for (let item of list) {
		if (!obj[item[key]]) {
			arr.push(item)
			obj[item[key]] = true
		}
	}
	return arr
}